import { render, staticRenderFns } from "./sim-info-change-installer-modal.vue?vue&type=template&id=2967f21a"
import script from "./sim-info-change-installer-modal.vue?vue&type=script&lang=js"
export * from "./sim-info-change-installer-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports